import { extend, reduce } from 'underscore';
import { editorialRawErrorCodeToErrorMessageMapping } from './editorial-raw-error-code-mapping';

// mapping of editorial error code to error message
export const editorialErrorCodeToErrorMessageMapping = extend(
  reduce(editorialRawErrorCodeToErrorMessageMapping, (result, value, key) => {
    // eslint-disable-next-line no-param-reassign
    result[`Error_Editorial_Raw_${key}`] = value;
    return result;
  }, {}),
  {
    ReasonString: _TL_('[Policy violation]: {{reason}}'),
    EditorialReasons_Default: _TL_('Microsoft Advertising policies'),
  }
);
